import { request, RequestInitWithRetry } from '../../lib/request';

export interface IDeviceAnomalyDataUsageHourlyParams {
  deviceId: string,
  from: number,
  to: number
}

export interface IDeviceAnomalyDataUsageHourlyPoint {
  date: string,
  mobile: number,
  wifi: number
}

export function getDeviceAnomalyDataUsageHourly(params: IDeviceAnomalyDataUsageHourlyParams) {
  return (options: RequestInitWithRetry): Promise<IDeviceAnomalyDataUsageHourlyPoint[]> => {
    const input = {
      path: '/api/core/anomalies-beta/devices/dataUsageHourly',
      body: params,
      method: 'post'
    };
    return request(input, options);
  };
}
